export default __webpack_public_path__ + "static/media/Nav-Statement.df26b3e9.svg";